import { Box, Stack, Typography } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { useCoverageSentence } from "src/hooks/useCoverageSentence";
import { useT } from "src/i18n";

// Flat trust strip — deliberately NOT a 3-up card grid. Bare teal icons +
// left-aligned heading + one line, grouped by space (breakpoint-free auto-fit),
// so it reads as an industrial spec row, not a SaaS feature-card template.
// The "Kattava verkosto" line is computed from live jerry coverage; the other two
// are static. See spec 2026-06-27-betonijerry-coverage-areas-design.md.
export default function LeadGenSection() {
    const t = useT();
    const { sentence: coverageSentence } = useCoverageSentence();
    const ITEMS = [
        {
            Icon: GroupIcon,
            title: t("landing.leadGen.saveTime.title"),
            body: t("landing.leadGen.saveTime.body"),
        },
        {
            Icon: LocationOnIcon,
            title: t("landing.leadGen.network.title"),
            body: coverageSentence,
        },
        {
            Icon: VerifiedUserIcon,
            title: t("landing.leadGen.trusted.title"),
            body: t("landing.leadGen.trusted.body"),
        },
    ];
    return (
        <Box component="section">
            <Typography
                variant="h4"
                component="h2"
                sx={{
                    textTransform: "uppercase",
                    letterSpacing: "0.04em",
                    fontSize: { xs: "1.5rem", md: "1.85rem" },
                    textAlign: { xs: "center", md: "left" },
                    mb: { xs: 3, md: 4 },
                }}
            >
                {t("landing.leadGen.heading")}
            </Typography>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))",
                    columnGap: { xs: 3, md: 5 },
                    rowGap: { xs: 3, md: 4 },
                }}
            >
                {ITEMS.map(({ Icon, title, body }) => (
                    <Stack key={title} spacing={1}>
                        <Stack direction="row" spacing={1.25} sx={{ alignItems: "center" }}>
                            <Icon sx={{ color: "primary.main", fontSize: 30, flexShrink: 0 }} />
                            <Typography variant="h6" component="h3" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                                {title}
                            </Typography>
                        </Stack>
                        <Typography variant="body2" sx={{ color: "text.secondary", maxWidth: "44ch" }}>
                            {body}
                        </Typography>
                    </Stack>
                ))}
            </Box>
        </Box>
    );
}
